import styles from './ConfiguratorDesktop.module.scss';
import cn from 'classnames';
import Button from '../../../../ui/Button/Button';
import Chevron from '../../../../Icons/Chevron';
import { Image } from '@sitecore-jss/sitecore-jss-react';
import React from 'react';
import { formatCurrency } from '../../utils';

export default function Desktop({ step, index, stepSelectedItem, onClickSelectType, onClickStep }) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.card}>
        <h3 className={styles.card_title}>{step?.title}</h3>
        <p className={styles.card_text}>{step?.text}</p>
        <ul className={styles.card_list}>
          {step?.items?.map((item) => {
            const [, before, bracketed] = item.title.match(/^(.*?)(\(.+\))$/) || [
              item.title,
              item.title,
              '',
            ];
            return (
              <li
                className={cn(styles.card_list_item, item.selected && styles.card_list_item_active)}
                key={item.id}
                onClick={() => onClickSelectType(item.id)}
              >
                <div>
                  <h4 className={styles.card_list_item_title}>
                    {before.trim()}{' '}
                    {bracketed && <span className={styles.noWrap}>{bracketed}</span>}
                  </h4>
                  <p className={styles.card_list_item_text}>{item.text}</p>
                </div>
                <p className={styles.card_list_item_price}>
                  {item.priceText || `Starting at ${formatCurrency(item.price, step?.priceUnit)}`}
                </p>
              </li>
            );
          })}
        </ul>
        <div className={styles.card_buttonWrapper}>
          <Button
            className={styles.card_buttonWrapper_button}
            onClick={() => onClickStep(index + 1)}
            isShowTooltip={false}
          >
            {step?.buttonText || 'Continue'}
            <Chevron />
          </Button>
        </div>
      </div>
      <div className={styles.image}>
        <Image field={stepSelectedItem?.image} />
      </div>
    </div>
  );
}
